// extracted by mini-css-extract-plugin
export default {"roomsceneSection":"RoomscenePage_roomsceneSection__W6f5D","content":"RoomscenePage_content__nQZk3"};